export default "__VITE_ASSET__D5bIip3A__"